import companyKanbanTaskList from './companyKanbanTaskList'
import dataProcessTemplateList from './dataProcessTemplateList'
import documentTemplateList from './documentTemplateList'
import incidentList from './incidentList'
import juridicTicketList from './juridicTicketList'
import kanbanTaskList from './kanbanTaskList'
import legalFrameworkList from './legalFrameworkList'
import legitimateInterestList from './legitimateInterestList'
import observerOrganizationList from './observerOrganizationList'
import organizationCompanyList from './organizationCompanyList'
import organizationList from './organizationList'
import privacyByDesignList from './privacyByDesignList'
import privacyPortalConfigurationList from './privacyPortalConfigurationList'
import profileList from './profileList'
import questionnaireList from './questionnaire'
import solicitationTicketList from './solicitationTicketList'
import tagList from './tagList'

const advisorProfileLists = {
  companyKanbanTaskList,
  dataProcessTemplateList,
  documentTemplateList,
  incidentList,
  juridicTicketList,
  kanbanTaskList,
  legalFrameworkList,
  legitimateInterestList,
  observerOrganizationList,
  organizationCompanyList,
  organizationList,
  privacyByDesignList,
  privacyPortalConfigurationList,
  profileList,
  questionnaireList,
  solicitationTicketList,
  tagList,
}

export default advisorProfileLists
